import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NoticeContainer, NoticeHeader, NoticeTitle, AllViewLink, NoticeList, NoticeItem } from "./Notice.styles";
import { noticeService, NoticeItem as NoticeItemType } from "services/noticeService";

export default function Notice() {
  const [notices, setNotices] = useState<NoticeItemType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get universityId from localStorage
        const universityId = localStorage.getItem('universityId');

        if (!universityId) {
          setError("대학 정보를 찾을 수 없습니다.");
          setLoading(false);
          return;
        }

        // Fetch notices using the universityId
        const noticeResponse = await noticeService.getNotices(
          Number(universityId),
          0,
          5,
          'createdAt,Desc'
        );

        setNotices(noticeResponse.content);
      } catch (error) {
        console.error("공지사항을 불러오는데 실패했습니다:", error);
        setError("공지사항을 불러올 수 없습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  const handleAllViewClick = () => {
    navigate(`/notice`);
  };

  const notiClick = (id: number) => {
    console.log(id);
    if (id !== null) {
      navigate(`/notice/${id}`);
    }
  };

  return (
    <NoticeContainer>
      <NoticeHeader>
        <NoticeTitle>공지사항</NoticeTitle>
        <AllViewLink onClick={handleAllViewClick}>전체보기</AllViewLink>
      </NoticeHeader>
      <NoticeList>
        {loading ? (
          <NoticeItem style={{ textAlign: 'center', cursor: 'default' }}>
            공지사항을 불러오는 중...
          </NoticeItem>
        ) : error ? (
          <NoticeItem style={{ textAlign: 'center', cursor: 'default' }}>
            {error}
          </NoticeItem>
        ) : notices.length === 0 ? (
          <NoticeItem style={{ textAlign: 'center', cursor: 'default' }}>
            등록된 공지사항이 없습니다.
          </NoticeItem>
        ) : (
          notices.map((noti) => (
            <NoticeItem key={noti.id} onClick={() => notiClick(noti.id)}>
              • {noti.title}
            </NoticeItem>
          ))
        )}
      </NoticeList>
    </NoticeContainer>
  );
}
